import React from 'react';

// Define theme colors for consistency
const colors = {
  primaryDark: '#091d32', // Background
  cardBackground: '#1d2d50',
  accent: '#45aaf2',     // Light Blue
  textWhite: '#fff',
  buttonPrimary: '#2ecc71', // A distinct color for the GitHub button
  buttonText: '#091d32',
};

// Define your web development projects data
const webProjects = [
  {
    id: 1,
    title: "Eastland Top Tutors Platform",
    technologies: "React, Node.js, MongoDB",
    description: "A comprehensive, full-stack educational platform connecting students with professional tutors. Features include secure user authentication, real-time scheduling, and content management.",
    // the styling in this image placeholder is really good. you can use it in other desings
    imagePlaceholder: <img 
        src="/adedeX95eastland.png" 
        alt="Education & Scheduling App"
        style={{
          width: '100%',           // Make the image take up the full width of its container
          height: '100%',          // Make the image take up the full height of its container
          objectFit: 'cover',      // CRITICAL: Crops the image to fill the container without stretching
          borderRadius: '12px',    // Match the container's corner radius
          display: 'block'         // Ensures no unwanted space below the image
        }}
      />,
    liveUrl: "https://www.eastlandtoptutors.com/",
    githubUrl: "https://github.com/dejoo10", 
  },
  {
    id: 2,
    title: "Cloud Resource Monitoring Dashboard",
    technologies: "React, D3.js, AWS SDK, Serverless",
    description: "A real-time dashboard visualizing cloud usage and cost metrics across multiple AWS accounts, built to help clients optimize their infrastructure spending.",
    imagePlaceholder: "Data Visualization",
    liveUrl: "https://github.com/dejoo10",
    githubUrl: "https://github.com/dejoo10",
  },
  {
    id: 3,
    title: "Portfolio Website V2",
    technologies: "React, Styled Components, Responsive Design",
    description: "This very site! A single-page application focused on showcasing technical expertise and professional consulting services with a modern, dark-theme aesthetic.",
    imagePlaceholder: <img 
        src="/adedeX95personal.png" 
        alt="Education & Scheduling App"
        style={{
          width: '100%',           // Make the image take up the full width of its container
          height: '100%',          // Make the image take up the full height of its container
          objectFit: 'cover',      // CRITICAL: Crops the image to fill the container without stretching
          borderRadius: '12px',    // Match the container's corner radius
          display: 'block'         // Ensures no unwanted space below the image
        }}
      />,
    liveUrl: "https://adedejibabalola.com/",
    githubUrl: "https://github.com/dejoo10", 
  },
];

const WebProjectsPage = () => (
  <div style={{ background: colors.primaryDark, minHeight: '100vh', color: colors.textWhite, padding: '50px 0' }}>
    <h1 style={{ color: colors.accent, textAlign: 'center', fontWeight: 'bold', fontSize: '2.5rem', marginBottom: '10px' }}>
      Web & API Development
    </h1>
    <p style={{ color: colors.textWhite, textAlign: 'center', fontSize: '1.1rem', marginBottom: '50px', opacity: 0.8 }}>
      Selected projects showcasing full-stack capabilities, modern frameworks, and API design.
    </p>

    <div style={{
      display: 'flex', 
      justifyContent: 'center', 
      flexWrap: 'wrap', 
      gap: 40, 
      padding: '0 20px',
    }}>
      {webProjects.map((project) => (
        <div 
          key={project.id} 
          style={{
            width: '100%', 
            maxWidth: '350px', 
            background: colors.cardBackground, 
            borderRadius: '16px', 
            padding: '25px', 
            boxShadow: '0 8px 25px rgba(0,0,0,0.3)',
            display: 'flex', 
            flexDirection: 'column', 
            transition: 'transform 0.3s',
          }}
          // Hover effect for the card
          onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-8px)'}
          onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
        >
          {/* Project Image Placeholder */}
          <div style={{
            width: '100%', 
            height: 180, 
            background: '#16213e', 
            borderRadius: '12px', 
            marginBottom: '18px',
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            color: colors.accent,
            fontSize: '1rem',
            fontWeight: 'bold',
            border: `1px dashed ${colors.accent}`,
            opacity: 0.7
          }}>
            {project.imagePlaceholder}
          </div>
          
          <h3 style={{ color: colors.accent, marginBottom: '5px', fontSize: '1.6rem' }}>
            {project.title}
          </h3>
          <p style={{ color: colors.textWhite, fontSize: '0.85rem', marginBottom: '15px', opacity: 0.9 }}>
            **Tech Stack:** {project.technologies}
          </p>
          
          <p style={{ color: colors.textWhite, fontSize: '0.95rem', lineHeight: 1.5, marginBottom: '25px' }}>
            {project.description}
          </p>
          
          {/* Action Buttons */}
          <div style={{ marginTop: 'auto', display: 'flex', gap: '15px', justifyContent: 'center' }}>
            
            {/* Live Site Link */}
            <a 
              href={project.liveUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              style={{
                textDecoration: 'none',
                padding: '10px 18px',
                borderRadius: '8px',
                background: colors.accent,
                color: colors.buttonText,
                fontWeight: 'bold',
                transition: 'background-color 0.2s',
                boxShadow: '0 4px 6px rgba(0,0,0,0.2)',
                // Subtle Hover
                onMouseEnter: (e) => e.target.style.backgroundColor = '#6ab8ff',
                onMouseLeave: (e) => e.target.style.backgroundColor = colors.accent
              }}
            >
              View Live Site
            </a>
            
            {/* GitHub Repo Link */}
            <a 
              href={project.githubUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              style={{
                textDecoration: 'none',
                padding: '10px 18px',
                borderRadius: '8px',
                background: colors.buttonPrimary,
                color: colors.buttonText,
                fontWeight: 'bold',
                transition: 'background-color 0.2s',
                boxShadow: '0 4px 6px rgba(0,0,0,0.2)',
                // Subtle Hover
                onMouseEnter: (e) => e.target.style.backgroundColor = '#58d68d',
                onMouseLeave: (e) => e.target.style.backgroundColor = colors.buttonPrimary
              }}
            >
              GitHub Repo
            </a>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default WebProjectsPage;
